export default {
    methods: {
        formatJsonString(jsonString, activity) {
            try {
                const jsonObject = JSON.parse(jsonString);
                if (activity == 'create-user') {
                    const allowedKeys = ["username", "contact_number", "role"];
                    return Object.entries(jsonObject)
                        .filter(([key]) => allowedKeys.includes(key))
                        .map(([key, value]) => `${key} = ${value !== null ? `${value}` : 'null;'}`)
                } else if (activity == 'delete-wingband') {
                    const allowedKeys = ["stag_registry","breeder_name","farm_name","farm_address","province","wingband_number","chapter","contact_number","feather_color","leg_color","comb_shape","nose_markings","feet_markings","season","wingband_date"];
                    return Object.entries(jsonObject)
                        .filter(([key]) => allowedKeys.includes(key))
                        .map(([key, value]) => `<li>${key} = ${value !== null ? value : 'null'}</li>`)
                        .join('');
                } else if (activity == 'bulk-delete-wingband') {
                    const records = Array.isArray(jsonObject) ? jsonObject
                        : (jsonObject.data && Array.isArray(jsonObject.data)) ? jsonObject.data
                        : [jsonObject];
                    return records.map((item, idx) =>
                        `<li>${idx + 1}. Stag Registry: <strong>${item.stag_registry || '-'}</strong> &nbsp;|&nbsp; Wingband No.: <strong>${item.wingband_number || '-'}</strong></li>`
                    ).join('');
                } else {
                    return Object.entries(jsonObject)
                        .map(([key, value]) => `<li>${key} : ${value !== null ? value : 'null'}</li>`)
                        .join('');
                }
            } catch (error) {
                return jsonString ? `<li>${jsonString}</li>` : '<li>No data</li>';
            }
        },
        dateTime(val) {
            //convert to date time string
            if (!val) {
                return ''
            }
            var date = new Date(val);
            return date.toLocaleDateString('en-us', { year: "numeric", month: "short", day: "2-digit", hour: '2-digit', minute: '2-digit' })
        },
        resultFormat(val, is_super) {
            if (val == "left" && is_super == true) {
                return 'SUPER PULA';
            }
            if (val == "right" && is_super == true) {
                return 'SUPER PUTI';
            }
            if (val == "left" && is_super == false) {
                return 'PULA';
            }
            if (val == "right" && is_super == false) {
                return 'PUTI';
            }
            if (val == "cancel") {
                return 'CANCEL';
            }
            // ? "SUPER PULA"
            // : r.match.result == "right" && r.match.is_super == true
            // ? "SUPER PUTI"
            // : r.match.result == "left" && r.match.is_super == false
            // ? "PULA"
            // : r.match.result == "right" && r.match.is_super == false
            // ? "PUTI"
            // : r.match.result == "cancel"
            // ? "CANCELLED"
            // : "WAITING RESULT"
        },
        dateOnly(val) {
            //convert to date time string
            if (!val) {
                return ''
            }
            var date = new Date(val);
            return date.toLocaleDateString('en-us', { year: "numeric", month: "short", day: "2-digit", timeZone:'Asia/Manila' })
        },
        timeOnly(val) {
            //convert to date time string
            if (!val) {
                return ''
            }
            var date = new Date(val);
            return date.toLocaleTimeString('en-us', { hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone:'Asia/Manila'  })
        },
        lastLogin(val) {
            var currDate = new Date(); // 20th April 2021
            var lastLogDate = new Date(val); // 10th April 2021
            // var total = currDate.getDate() - lastLogDate.getDate();
            // var totaldays = currDate.getDate() - lastLogDate.getDate();
            var totalyear = currDate.getFullYear() - lastLogDate.getFullYear();
            var totalmonth = currDate.getMonth() - lastLogDate.getMonth();
            // var totalhours = currDate.getHours() - lastLogDate.getHours();
            // var totalminutes = currDate.getMinutes() - lastLogDate.getMinutes();
            var difference = currDate.getTime() - lastLogDate.getTime(); // This will give difference in milliseconds
            var resultInMinutes = Math.round(difference / 60000);
            var days = parseInt((currDate - lastLogDate) / (1000 * 60 * 60 * 24));

            //get hours
            var diffHour = (currDate.getTime() - lastLogDate.getTime()) / 1000;
            diffHour /= (60 * 60);
            var resultInHours = Math.abs(Math.round(diffHour));
            // return lastLogDate +' === '+ days;
            if (resultInMinutes <= 69) {
                if (resultInMinutes == 1) {
                    return resultInMinutes + ' min ago';
                } else if (resultInMinutes == 0) {
                    return '0 min ago';
                } else {
                    return resultInMinutes + ' mins ago';
                }
            }
            if (resultInHours <= 24) {
                if (resultInHours == 1) {
                    return resultInHours + ' hour ago';
                } else {
                    return resultInHours + ' hours ago';
                }
            }
            if (days <= 30) {
                if (days == 1) {
                    return days + ' day ago';
                } else {
                    return days + ' days ago';
                }
            }
            if (totalmonth <= 12) {
                if (totalmonth == 1) {
                    return totalmonth + ' month ago';
                } else {
                    return totalmonth + ' months ago';
                }
            }
            if (totalmonth > 12) {
                if (totalyear == 1) {
                    return totalyear + ' year ago';
                } else {
                    return totalyear + ' years ago';
                }
            }
            // if (totalyear === 0) {
            //     if (totalmonth === 0) {
            //         if (total === 0) {
            //             if (totalhours === 0) {
            //                 if (totalminutes === 0 || totalminutes === 1) {
            //                     return totalminutes + " " + 'min ago'
            //                 } else {
            //                     return totalminutes + " " + 'mins ago'
            //                 }
            //             } else {
            //                 if (totalhours === 1) {
            //                     return totalhours + " " + 'hour ago'
            //                 }
            //                 else {
            //                     return totalhours + " " + 'hours ago'
            //                 }
            //             }
            //         } else {
            //             if (total === 1) {
            //                 return total + " " + 'day ago'
            //             }
            //             else {
            //                 return total + " " + 'days ago'
            //             }

            //         }
            //     }
            //     else {
            //         if (totalmonth === 1) {
            //             return totalmonth + " " + 'month ago'
            //         }
            //         else {
            //             return totalmonth + " " + 'months ago'
            //         }
            //     }
            // } else {
            //     if (totalyear === 1) {
            //         return totalyear + " " + 'year ago'
            //     }
            //     else {
            //         return totalyear + " " + 'years ago'
            //     }
            // }
            // if (totalminutes === 60) {
            //     if (totalhours === 24) {
            //         if (totaldays >= 30) {
            //             if (totalmonths >= 12) {
            //                 if(totalyear === 1){
            //                     return totalyear + " " + 'year ago';
            //                 }
            //                 else{
            //                     return totalyear + " " + 'years ago';
            //                 }
            //             } else {
            //                 if(totalmonths > 1){
            //                     return totalmonths + " " + 'months ago';
            //                 }
            //                 else{
            //                     return totalmonths + " " + 'month ago';
            //                 }

            //             }
            //         } else {
            //             if(totaldays > 1){
            //                 return totaldays + " " + 'days ago';
            //             }
            //             else{
            //                 return totaldays + " " + 'day ago';
            //             }

            //         }
            //     } else {
            //         if(totalhours > 1){
            //             return totalhours + " " + 'hours ago';
            //         }
            //         else{
            //             return totalhours + " " + 'hour ago';
            //         }

            //     }
            // } else {
            //     if(totalminutes > 1){
            //         return totalminutes + " " + 'mins ago';
            //     }
            //     else{
            //         return totalminutes + " " + 'min ago';
            //     }

            // }
            // return currDate.getDate() + ' == ' + lastLogDate.getDate();
        },
        dateYmD(val) {
            var date = new Date(val);
            // const offset = date.getTimezoneOffset()
            // date = new Date(date.getTime() - (offset * 60 * 1000))



            var hr = date.getHours()
            var min = date.getMinutes()
            var sec = date.getSeconds()

            // var ampm = ' PM '
            // if (hr < 12) {
            //     ampm = ' AM '
            // }
            if (hr > 12) {
                hr -= 12
            }
            if (hr < 10) {
                hr = '0' + hr
            }
            if (min < 10) {
                min = '0' + min
            }
            if (sec < 10) {
                sec = '0' + sec
            }
            return date.toISOString().split('T')[0] //+ ' ' + hr + ':' + min + ampm
        },
        inputNumToString(val) {
            var str = val ? val.toString() : ''

            // check if have decimal

            return (val < 0 ? '-' : '') + str.replace(/^0+/, '')
                .replace(/[^0-9]/g, '')
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        },
        numToString(val) {
            var str = val ? val.toString() : ''

            // check if have decimal

            return val > 0 ? (val < 0 ? '-' : '') + str.replace(/^0+/, '')
                .replace(/[^0-9]/g, '')
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : '0'
        },
        stringToNum(val) {
            return parseInt(val.replace(/[^0-9]/g, ''))
        },
    }
}